import {breakpointsTailwind, useBreakpoints, useMediaQuery} from "@vueuse/core";
import {computed} from "vue";

export const useNamaBreakpoints = () => {

  const isMobile = useMediaQuery("(max-width:1024px)");
  const isTablet = useMediaQuery("(min-width:1024px) and (max-width:1100px)");
  const isLaptop = useMediaQuery("(min-width:1025px) and (max-width:1300px)");
  const isDesktop = computed(() => !isMobile.value)

  const twBreakpoints = useBreakpoints(breakpointsTailwind);
  const isXSmall = twBreakpoints.smallerOrEqual("sm"); //<= 640px

  return {
    isXSmall,
    isMobile,
    isTablet,
    isLaptop,
    isDesktop
  }
}
